<script lang="ts">
  export let time: number;
  export let label: string;
  export let divider: string;
</script>

<div class="flex flex-col justify-center align-center">
  <span
    class="text-hero1 font-bold text-center text-p100"
    id={label.toLowerCase()}
  >
    {time.toString().padStart(2, "0")}
  </span>
  <div class="uppercase text-center">
    {time === 1 ? label.replace("s", "") : label}
  </div>
</div>
{#if !!divider}
  <span
    class="text-hero1 font-bold text-cente text-p100"
    id={label.toLowerCase()}>:</span
  >
{/if}
